import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

export const ContentContainerStyle = css`
  box-sizing: content-box;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
  ${fluidProp(['padding-left', 'padding-right'], '16px', '48px')}

  // Don't add padding when nested
  & & {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ContentContainer = styled.div`
  ${ContentContainerStyle}
`;

export default ContentContainer;
